export default __webpack_public_path__ + "static/media/wildlife08.68a4936b.png";